"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = e => {
    const text = e.target || `Rating Render `;
    if (!text)
        return;
    if (typeof window.ctConstants === 'undefined')
        return;
    const analyticsEvent = {};
    analyticsEvent.eventInfo = {
        type: window.ctConstants.trackEvent,
        eventAction: window.ctConstants.rrRenders,
        eventLabel: text.vendor,
        eventValue: 1,
    };
    analyticsEvent.attributes = { nonInteractive: { nonInteraction: 1 } };
    analyticsEvent.category = {
        primaryCategory: window.ctConstants.custom,
    };
    analyticsEvent.subcategory = 'Read';
    window.digitalData.event.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
